// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.ButtonGroupField = (function(){
  function ButtonGroupField(cfg, index, form) {
    this._super.apply(this, arguments); // call generic TextField constructor
  }
  var proto = ButtonGroupField.prototype = {
    radio: true, /* whether the group acts as radio buttons or checkboxes */
    initialValue: undefined,
    helpText: false,
    className: undefined, /* class to add to $elm */
    _template: 
      '<div class="form-group">' +
        '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
        '<div class="col-sm-<%=helpText? "8" : "9"%>">' +
          '<div class="btn-group btn-group-justified" role="group">' +
          '</div>' +
        '</div>' +
      '<% if (helpText) { %>' +
        '<div class="col-sm-1 hidden-xs">' +
          '<i class="fa fa-question-circle-o" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
        '</div>' +
      '<% } %>'+
      '</div>',
    data: [
      /**
       * Format (if <jQuery>, must be a button with a data-value attribute):
       * {
       *   value: <String>, // value assigned to this button, converted to string if necesarry
       *   content: <String>|<jQuery>, // content to display inside button
       *   classes: <Array> // optional array of additional classes to give to button
       * } | <jQuery>
       */
    ],
    activeClasses: ["active", "btn-primary"] // note: will be removed once button is unchecked - do not overlap with classes from `data`
  };
  proto._get$Element = function(){
    this._super.prototype._get$Element.apply(this, arguments);
    this.$group = $(".btn-group", this.$elm);

    // add buttons to the btn-group
    var $btns = $();
    var self = this;
    $(this.data).each(function(){
      var $btn = this;
      if (!(this instanceof jQuery)) {
        // ensure default classes
        if (!this.classes || !this.classes.length) {
          this.classes = ["btn-default"];
        }
        // create the button
        $btn = $('<button type="button" class="btn" data-value="'+this.value+'"></button>'); // generate button
        $btn.addClass((this.classes || []).join(" ")); // add classes
        $btn.append(this.content); // add content
      }

      // bind button and add it to list of buttons
      $btn.on("click", self._onClicked.bind(self, $btn));

      // we must wrap the button in a container for the justification to work
      // see http://getbootstrap.com/components/#with-button-elements
      var $container = $("<div class='btn-group' role='group'></div>");
      $container.append($btn);
      $btns = $btns.add($container);
    });
    $btns.appendTo(this.$group);

    // set the current value to the initial value
    this.setValue(this.initialValue);

    if (this.className) {
      this.$elm.addClass(this.className);
    }

    // return the element
    return this.$elm;
  };
  proto._onClicked = function($btn){
    // if we should act as radio buttons, unactivate the currently active button
    if (this.radio) {
      $("button."+this.activeClasses.join("."), this.$group).removeClass(this.activeClasses.join(" "));
    }
    var shouldActivate = this.radio || !$btn.is("."+this.activeClasses.join(", ."));
    $btn.toggleClass(this.activeClasses.join(" "), shouldActivate);

    // update the value after we've changed which buttons are active
    this._updateValue();
  };
  proto._updateValue = function(){
    var $active = $("button."+this.activeClasses.join("."), this.$group),
        outp = [];
    $active.each(function(){
      outp.push($(this).attr("data-value"));
    });

    // if we're a radio button, output a single value
    // if we're not, output an array of active values
    var _val = this._value;
    this._value = this.radio ? outp[0] : outp;

    if (_val !== this._value) {
      this.$elm.trigger("change");
      if (this.onChange) {
        this.onChange(this.getValue());
      }
    }
    
    return this._value;
  };
  proto.getValue = function(){
    return this._value;
  };
  proto.setValue = function(val){
    // turn val into an array, so we can handle both single and multi vals
    val = [].concat(val);
    var found = false,
        self = this;
    // unactivate all currently active buttons
    $("button."+this.activeClasses.join("."), this.$group).removeClass(this.activeClasses.join(" "));
    // then activate the ones that match the passed values
    $(val).each(function(){
      var $btn = $("button[data-value='"+this+"']", self.$group);
      if ($btn.length) { // if a button with that value was found
        $btn.click();
        found = true;
      }
    });

    // if we didn't find any of the values, return false
    return found;
  };
  proto.clearValue = function(val){
    this.setValue(this.defaultValue);
    return true;
  };

  // inherit from generic field
  PD.forms.fields.register(["buttonGroup", "ButtonGroupField"], ButtonGroupField);

  return ButtonGroupField;
})();
